import type { IMAGE_DATA, IMAGE_PARAMS, IMAGE_PARAMS_DEVICE } from './types'

import { DEFAULT_MARGIN, DEFAULT_PADDING } from '../const'

const DEFAULT_IMAGE_PARAMS_DEVICE = (): IMAGE_PARAMS_DEVICE => ({
  hidden: false,
  width: {
    value: 50,
    unit: '%',
  },
  placeSelf: 'center',
  padding: DEFAULT_PADDING(),
  margin: DEFAULT_MARGIN(),
})

export const DEFAULT_IMAGE_PARAMS = (): IMAGE_PARAMS => ({
  pc: DEFAULT_IMAGE_PARAMS_DEVICE(),
  tablet: DEFAULT_IMAGE_PARAMS_DEVICE(),
  mobile: {
    ...DEFAULT_IMAGE_PARAMS_DEVICE(),
    width: {
      value: 100,
      unit: '%',
    },
  },
})

export const DEFAULT_IMAGE_DATA = (): IMAGE_DATA => ({
  id: null,
  classes: null,
  type: 'image',
  data: {
    image: null,
    pendingImage: null,
    size: 'm',
    crop: 'structured-image-crop-none',
  },
})